import { Menu, rem } from '@mantine/core';
import * as icons from '@sloyd/icons';
import { invokeEvent } from 'shared-base';
import { IUser } from '../../types';
import UserButton from '../UserButton/UserButton';
import { items } from './UserMenu.data';
import { Wrapper } from './UserMenu.style';
import { filter } from './UserMenu.utils';

export type UserMenuProps = {
  user: IUser;
};

export function UserMenu(props: UserMenuProps) {
  const { user } = props;
  const { email, username, picture } = user;

  function onClick(item: Json) {
    invokeEvent('nav', { path: item.path });
  }

  function renderItem(item: Json) {
    const { title, icon } = item;
    const Icon = (icons as any)[icon];

    return (
      <Menu.Item
        key={item.id}
        leftSection={<Icon style={{ width: rem(14), height: rem(14) }} />}
        onClick={() => onClick(item)}
      >
        {title}
      </Menu.Item>
    );
  }

  function renderItems() {
    return items
      .filter((link) => filter(link, { isEmployee: user.isEmployee }))
      .filter((item: Json) => !item.isHidden)
      .map((item: Json) => renderItem(item));
  }

  return (
    <Wrapper className='UserMenu-wrapper' data-testid='UserMenu-wrapper'>
      <Menu withArrow>
        <Menu.Target>
          <UserButton image={picture} name={username} email={email} />
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Label>Account</Menu.Label>
          {renderItems()}
        </Menu.Dropdown>
      </Menu>
    </Wrapper>
  );
}

export default UserMenu;
